import { CustomAlarmListItem } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/settings-devices-custom-alarm-list.model';
import { updateCustomAlarmsActiveStatus } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/service/custom-alarm-list.service';
import { showErrorNotification, showSuccessNotification } from 'core/utils/notification-service';
import { useTranslation } from 'core/i18n';

export const useCustomAlarmsActivation = () => {
    const { t } = useTranslation();

    const changeCustomAlarmsActiveStatus = (customAlarms: CustomAlarmListItem[], newValue: boolean) => {
        const ids = customAlarms.map((item) => item.id);
        return updateCustomAlarmsActiveStatus(ids, newValue)
            .then(() =>
                showSuccessNotification(
                    t(
                        newValue
                            ? 'settings.devices.custom-alarms.activation.modal.notifications.activation.success'
                            : 'settings.devices.custom-alarms.activation.modal.notifications.deactivation.success'
                    )
                )
            )
            .catch((error) => {
                showErrorNotification(
                    t(
                        newValue
                            ? 'settings.devices.custom-alarms.activation.modal.notifications.activation.error'
                            : 'settings.devices.custom-alarms.activation.modal.notifications.deactivation.error'
                    )
                );
                throw error;
            });
    };

    return {
        changeCustomAlarmsActiveStatus,
    };
};
